import DF from 'DisplayFramework';
import { Form } from 'antd';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import ModalControllerNV from 'components/ModalControllerNV';
import moment from 'moment';
import React, {  useMemo } from 'react';
// import { useQuery } from 'react-query';
import {
  PurchaseOrderListSearchResponse,
  // getPurchaseOrderListByProposalID
} from 'services/purchaseOrder';
import { toCurrency } from 'utils/utils';
// import { toDatePickerDate } from 'utils/utils2';
import PurchaseOrderDetailsModal from './PurchaseOrderDetailsModal';

type PurchaseOrderListTableProps = {
  ctrid: number;
  currcode: string;
  refetchProp: any;
};

const PurchaseOrderListTable = (props: PurchaseOrderListTableProps) => {
  const { ctrid, currcode, refetchProp } = props;
  const [form] = Form.useForm();
  const fieldName = 'PuOrderListTab';

  // const { data, refetch } = useQuery(
  //   ['getPurchaseOrderListByProposalID', { ctrid, refetchProp }],
  //   () =>
  //     getPurchaseOrderListByProposalID({
  //       ctrid: ctrid,
  //       postatus: ''
  //     }).then((res) => res.list || []),
  //   { enabled: true }
  // );
  // useEffect(() => {
  //   if (data) {
  //     form.setFieldsValue({
  //       [fieldName]: data.map((po) => ({
  //         ...po,
  //         postatusdate: toDatePickerDate(po.podate)
  //       }))
  //     });
  //   } else {
  //     form.setFieldsValue({
  //       [fieldName]: []
  //     });
  //   }
  // }, [form, data, refetch, currcode, ctrid]);

  const columns = useMemo<DataGridColDef<PurchaseOrderListSearchResponse>[]>(
    () => [
      {
        dataIndex: 'poreference',
        render: (value, record) => (
          <ModalControllerNV
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{value}</a>
            )}
            modal={({ setVisible, visible }) => (
              <PurchaseOrderDetailsModal
                visible={visible}
                onCancel={() => setVisible(false)}
                poid={record.poid}
              />
            )}
          />
        )
      },
      {
        dataIndex: 'podescription'
      },
      {
        dataIndex: 'poexternalref'
      },
      {
        dataIndex: 'ponetamount',
        render: (value, record) => toCurrency(value, currcode)
      },
      {
        dataIndex: 'pogrossamount',
        render: (value, record) => toCurrency(value, currcode)
      },
      {
        dataIndex: 'postatuslabel'
      },
      {
        dataIndex: 'postatusdate',
        render: (value, record) => moment(value).format('YYYY-MM-DD')
      }
    ],
    [currcode]
  );
  return (
    <DF.Provider pagcode="puordertab">
      <Form form={form}>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => {
            const puroder: PurchaseOrderListSearchResponse[] =
              getFieldValue(fieldName);

            return (
              <DataGrid rowKey="ctrid" columns={columns} dataSource={puroder} />
            );
          }}
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};
export default PurchaseOrderListTable;
